import { render, staticRenderFns } from "./UsersRolesPermissions.vue?vue&type=template&id=7c39d463&scoped=true"
import script from "./UsersRolesPermissions.vue?vue&type=script&lang=js"
export * from "./UsersRolesPermissions.vue?vue&type=script&lang=js"
import style0 from "./UsersRolesPermissions.vue?vue&type=style&index=0&id=7c39d463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39d463",
  null
  
)

export default component.exports